/**
 * התג החתימתי של המערכת: מספר העובדים על לוח כחול-לילה עם פס אדום תחתון —
 * אותו מבנה כמו ה-ש.א בלוגו. זה המקום היחיד שבו הפס האדום מופיע ברשימות,
 * כדי שהעין תמצא את המספר מיד.
 */
export function WorkerCountTag({ count, size = 'md' }: { count: number; size?: 'md' | 'lg' }) {
  const large = size === 'lg';
  return (
    <span
      className={[
        'tabular inline-flex shrink-0 flex-col items-center justify-center rounded-[8px] bg-tag text-tag-ink',
        'shadow-[inset_0_-4px_0_var(--color-tag-bar)]',
        large ? 'min-w-24 px-4 pb-3 pt-2.5' : 'min-w-14 px-2 pb-2 pt-1.5',
      ].join(' ')}
      aria-label={`${count} עובדים`}
    >
      <span className={large ? 'text-display font-extrabold' : 'text-[21px] font-extrabold leading-none'}>{count}</span>
      <span className={large ? 'mt-1 text-[12px] font-medium text-steel' : 'mt-0.5 text-[11px] font-medium text-steel'}>עובדים</span>
    </span>
  );
}
